// extracted by mini-css-extract-plugin
module.exports = {"root":"FeedEditor_root__UpM9C","feedActionBtn":"FeedEditor_feedActionBtn__Gx7ty"};